import React from "react";
import './EmptyTodo.css'

function EmptyTodo(){
    return(
        <p className="taskApp__tagEmpty">Crea tu primer TODO</p>
    )
}
export { EmptyTodo };